import axios from 'axios'

const DEPLOYED_API = 'https://poultryfy.com/api/v1'
const LOCAL_API = 'http://localhost:5001/api/v1'

// REACT_APP_API_URL pins one backend. Otherwise, when the site itself runs on
// localhost, try a local backend first and fall back to the deployed one.
// Real visitors only ever hit the deployed API.
const candidates = () => {
    if (process.env.REACT_APP_API_URL) return [process.env.REACT_APP_API_URL]
    const { hostname } = window.location
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1'
    return isLocal ? [LOCAL_API, DEPLOYED_API] : [DEPLOYED_API]
}

let resolvedBase = null

// GET a path from the first backend that answers. Only a network failure
// (backend not running) moves on to the next one; HTTP errors are returned.
export const apiGet = async (path) => {
    const bases = resolvedBase ? [resolvedBase] : candidates()
    let lastError
    for (const base of bases) {
        try {
            const res = await axios.get(base + path, { timeout: 8000 })
            resolvedBase = base
            return res.data
        } catch (err) {
            if (err.response) throw err
            lastError = err
        }
    }
    throw lastError
}
